import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import React, { Fragment, useMemo } from 'react';
import InfoTooltip from '@/components/molecules/InfoTooltip';
import { HeaderWithTooltip } from '@/utils/types';
import { CryptoSlides } from '../CryptoCarousel/types';
import DesktopTable from '../DesktopTable';
import DesktopTableSkeleton from '../DesktopTable/partials/DesktopTableSkeleton';
import MobileCrypto from '../MobileCrypto';
import MobileCryptoSkeleton from '../MobileCrypto/partials/MobileCryptoSkeleton';
type Props = {
  rows: CryptoSlides | null | undefined;
  headers: HeaderWithTooltip[];
  variant: 'sellFeesAndLimits' | 'buyFeesAndLimits';
  isLoading?: boolean;
};
type KeyValue = {
  [key: string]: CryptoSlides;
};
const FeesTables = t0 => {
  const $ = _c(7);
  const {
    rows,
    headers,
    variant,
    isLoading
  } = t0;
  let t1;
  if ($[0] !== rows) {
    const sellFeesAndLimits = {};
    const buyFeesAndLimits = {};
    rows?.forEach(row => {
      row.coin_extras?.forEach(item => {
        if (item.type === "sell") {
          if (!sellFeesAndLimits[item.service_name as string]) {
            sellFeesAndLimits[item.service_name as string] = [];
          }
          sellFeesAndLimits[item.service_name as string].push({
            ...row,
            service_description: item.service_description,
            service_name: item.service_name
          });
        } else {
          if (!buyFeesAndLimits[item.service_name as string]) {
            buyFeesAndLimits[item.service_name as string] = [];
          }
          buyFeesAndLimits[item.service_name as string].push({
            ...row,
            service_description: item.service_description,
            service_name: item.service_name
          });
        }
      });
    });
    t1 = {
      buyFeesAndLimits,
      sellFeesAndLimits
    };
    $[0] = rows;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const tables = t1;
  if (isLoading) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <><DesktopTableSkeleton /><MobileCryptoSkeleton /></>;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t2;
  if ($[3] !== headers || $[4] !== tables || $[5] !== variant) {
    t2 = Object.entries(tables[variant]).map(t3 => {
      const [key, value] = t3;
      const tooltipDescription = value?.find(item_0 => item_0.service_name == key)?.service_description;
      return <Fragment key={key}><DesktopTable feesRow={key} variant={variant} rows={value} headers={headers} tooltip={<InfoTooltip description={tooltipDescription} />} /><MobileCrypto feesRow={key} variant={variant} rows={value} headers={headers} tooltip={<InfoTooltip description={tooltipDescription} />} /></Fragment>;
    });
    $[3] = headers;
    $[4] = tables;
    $[5] = variant;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default FeesTables;